/**
 * Scrolltrigger Scroll Check
 * if (
      document.querySelector("main#page-home") ||
      document.querySelector("main#page-quienes-somos")
    ) {
      if ($(document).scrollTop() > 170) {
        $(" main ").removeClass("default").addClass("fijo");
      } else {
        $(" main ").removeClass("fijo").addClass("default");
      }
      $(document).on("scroll", function () {
        if ($(document).scrollTop() > 170) {
          $(" main ").removeClass("default").addClass("fijo");
        } else {
          $(" main ").removeClass("fijo").addClass("default");
        }
      });
    } else {
      if ($(document).scrollTop() > 170) {
        $(" main ").removeClass("default").addClass("fijo");
      } else {
        $(" main ").removeClass("default").addClass("fijo");
      }
      $(document).on("scroll", function () {
        if ($(document).scrollTop() > 170) {
          $(" main ").removeClass("default").addClass("fijo");
        } else {
          $(" main ").removeClass("default").addClass("fijo");
        }
      });
    }
 */
export function initScrolltriggerNav () {
  if (
    document.querySelector ('main#page-home') ||
    document.querySelector ('main#page-single-habitacione')
  ) {
    if ($ (document).scrollTop () > 170) {
      $ (' main ').removeClass ('default').addClass ('fijo');
    } else {
      $ (' main ').removeClass ('fijo').addClass ('default');
    }
    ScrollTrigger.create ({
      start: 'top -30%',
      onUpdate: self => {
        $ ('main').addClass ('scrolled');
        $ (' main ').removeClass ('default').addClass ('fijo');
      },
      onLeaveBack: () => {
        $ ('main').removeClass ('scrolled');
        $ (' main ').removeClass ('fijo').addClass ('default');
      },
    });
  } else {
    if ($ (document).scrollTop () > 170) {
      $ (' main ').removeClass ('fijo').addClass ('fijo');
    } else {
      $ (' main ').removeClass ('fijo').addClass ('fijo');
    }
    ScrollTrigger.create ({
      start: 'top -30%',
      onUpdate: self => {
        $ ('main').addClass ('scrolled');
        $ (' main ').removeClass ('fijo').addClass ('fijo');
      },
      onLeaveBack: () => {
        $ ('main').removeClass ('scrolled');
        $ (' main ').removeClass ('fijo').addClass ('fijo');
      },
    });
  }

  const isMobile = window.innerWidth <= 540;

  if (!isMobile) {
    // Hide menu on scroll
    var actionNav = gsap.to ('.site-header__inner', {
      yPercent: '-=180',
      duration: 0.5,
      ease: 'power2.inOut',
      paused: true,
      delay: 1,
    });

    ScrollTrigger.create ({
      trigger: 'body', // Changed to body to measure absolute document scroll
      start: 'top+100 top', // Triggers exactly 100px after the top of the body hits the viewport top
      end: 99999,
      onUpdate: ({direction}) => {
        // Streamlined scroll direction logic
        if (direction === -1) {
          actionNav.reverse ();
        } else if (direction === 1) {
          actionNav.play ();
        }
      },
      onLeaveBack: () => {
        // Ensures the navbar resets cleanly when scrolling back to the very top (< 100px)
        actionNav.reverse ();
      },
    });
  }
}
/**
 * Hamburger Nav Open/Close
 */
export function initHamburgerNav () {
  const header = document.querySelector ('.site-header');
  const toggle = document.querySelector ('.menu-toggle');
  const mobileMenu = document.querySelector ('.mobile-menu');
  if (!header || !toggle || !mobileMenu) {
    return;
  }

  // =================================================
  // ABRIR / CERRAR
  // =================================================
  toggle.addEventListener ('click', () => {
    const isOpen = header.classList.toggle ('menu-open');
    toggle.setAttribute ('aria-expanded', isOpen ? 'true' : 'false');
    toggle.setAttribute ('aria-label', isOpen ? 'Cerrar menú' : 'Abrir menú');
    document.body.classList.toggle ('menu-is-open', isOpen);
  });
  // =================================================
  // CERRAR AL HACER CLICK EN UN LINK
  // =================================================
  const links = mobileMenu.querySelectorAll ('a');
  links.forEach (link => {
    link.addEventListener ('click', () => {
      header.classList.remove ('menu-open');
      toggle.setAttribute ('aria-expanded', 'false');
      toggle.setAttribute ('aria-label', 'Abrir menú');
      document.body.classList.remove ('menu-is-open');
    });
  });
  // =================================================
  // ESC
  // =================================================
  document.addEventListener ('keydown', event => {
    if (event.key === 'Escape' && header.classList.contains ('menu-open')) {
      header.classList.remove ('menu-open');
      toggle.setAttribute ('aria-expanded', 'false');
      toggle.setAttribute ('aria-label', 'Abrir menú');
      document.body.classList.remove ('menu-is-open');
    }
  });


}
